export const COOKIE_AUTH = {
  TOKEN: "traztru-token",
  TOKEN_EXPIRE_DAYS: 200,
	USER: "traztru-user"
};
